import React, { useState } from 'react'
import { Select } from 'antd'
import './style.css'

const ArrowSelect = (
	<svg
		fill="none"
		height="7"
		viewBox="0 0 12 7"
		width="12"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M11.5917 0.841957C11.5142 0.76385 11.422 0.701855 11.3205 0.659548C11.2189 0.617241 11.11 0.595459 11 0.595459C10.89 0.595459 10.7811 0.617241 10.6795 0.659548C10.578 0.701855 10.4858 0.76385 10.4083 0.841957L6.59168 4.65862C6.51421 4.73672 6.42204 4.79872 6.32049 4.84103C6.21894 4.88333 6.11002 4.90511 6.00001 4.90511C5.89 4.90511 5.78108 4.88333 5.67953 4.84103C5.57798 4.79872 5.48581 4.73672 5.40834 4.65862L1.59168 0.841957C1.51421 0.76385 1.42204 0.701855 1.32049 0.659548C1.21894 0.617241 1.11002 0.595459 1.00001 0.595459C0.889999 0.595459 0.781078 0.617241 0.679529 0.659548C0.577979 0.701855 0.485812 0.76385 0.408343 0.841957C0.253134 0.998092 0.166016 1.2093 0.166016 1.42946C0.166016 1.64961 0.253134 1.86082 0.408343 2.01695L4.23334 5.84195C4.70209 6.31011 5.33751 6.57308 6.00001 6.57308C6.66251 6.57308 7.29792 6.31011 7.76667 5.84195L11.5917 2.01695C11.7469 1.86082 11.834 1.64961 11.834 1.42946C11.834 1.2093 11.7469 0.998092 11.5917 0.841957Z"
			fill="black"
			fillOpacity="0.5"
		/>
	</svg>
)

const CustomSelect = (props) => {
	const { children, className, setPropsSate, onChange: onChangeFromProps, showArrow, value: inputValue, readOnly, onSearch: onSeacrhFromProps, ...otherProps } = props
	const [value, setValue] = useState(null)
	const [searchValue, setSearchValue] = useState(null)
	const onChange = (value, target) => {
		if (!readOnly){
			setValue(value)
			if (onChangeFromProps)
				onChangeFromProps(value, target)
			if (setPropsSate) {
				setPropsSate(value)
			}

		}
	}
	const onSearch = (value) => {
		if (!readOnly){
			setSearchValue(value)
			if (onSeacrhFromProps)
				onSeacrhFromProps(value)
		}
	}
	return (
		<Select
			className={ `custom-select ${ className ?? '' } ` }
			showArrow={ !value && !inputValue && !searchValue }
			value={ inputValue }
			onChange={ onChange }
			onSearch={ onSearch }
			{ ...otherProps }
			suffixIcon={ ArrowSelect }
		>
			{ children }
		</Select>
	)
}

export default CustomSelect
